import CoreDialogInstance from './dialog';

export { CoreDialogInstance };
